module.exports = require("./../../_gen/motion/easing/Quart");